import React, { ReactNode } from 'react';

import { motion, Variants } from 'framer-motion';



interface SectionProps {

  id: string;

  title: string;

  children: ReactNode;

  className?: string;

}



const sectionVariants: Variants = {

  offscreen: {

    opacity: 0,

    y: 50,

  },

  onscreen: {

    opacity: 1,

    y: 0,

    transition: {

      type: 'spring',

      bounce: 0.2,

      duration: 1,

    },

  },

};



export const Section: React.FC<SectionProps> = ({ 

  id, 

  title, 

  children, 

  className = '',

}) => {

  return (

    <section 

      id={id} 

      className={`relative py-24 px-4 sm:px-6 lg:px-8 ${className}`}

    >

      <motion.div

        initial="offscreen"

        whileInView="onscreen"

        viewport={{ once: true, amount: 0.1 }}

        className="max-w-7xl mx-auto relative"

      >

        <motion.h2 

          variants={sectionVariants}

          className="font-display text-center text-4xl md:text-6xl font-bold text-[var(--color-foreground)] mb-16 tracking-tight"

        >

          {title}

        </motion.h2>

        <motion.div 

          variants={sectionVariants}

        >

          {children}

        </motion.div>

      </motion.div>

    </section>

  );

};



export default Section;

